


























import { defineComponent, PropType, computed } from '@vue/composition-api';
import { TextDraft } from '@oare/types';
import CodeDiff from 'vue-code-diff';

export default defineComponent({
  name: 'DraftDiffPopup',
  components: {
    CodeDiff,
  },
  props: {
    viewingDraft: {
      type: Object as PropType<TextDraft>,
      required: true,
    },
  },
  setup({ viewingDraft }) {
    const draftText = computed(() =>
      viewingDraft.content
        .map(({ side, text }) => `${side}\n${text}`)
        .join('\n')
    );

    return {
      draftText,
    };
  },
});
